import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule, MatCheckboxModule, MatFormFieldModule, MatInputModule } from '@angular/material';

import { FuseSharedModule } from '@fuse/shared.module';
import {sessionConfirmDialogModule} from '@fuse/components/confirm-dialog-session/confirm-dialog-sesssion.module';
import { Login2Component } from 'app/main/pages/authentication/login-2/login-2.component';
import { HttpModule,Http } from '@angular/http';
import {errorDialogDuplicate} from './error/error-example';
import { MatDialogRef,MatDialogModule} from '@angular/material';
import { sessionConfirmDialogComponent } from '@fuse/components/confirm-dialog-session/confirm-dialog-session.component';
const routes = [
    {
        path     : 'auth/login-2',
        component: Login2Component,
        
    },
    {
            path     : ':id',
        component: errorDialogDuplicate
    }
    
];

@NgModule({
    declarations: [
        Login2Component,
        errorDialogDuplicate
    ],
    imports     : [
        HttpModule,
        RouterModule.forChild(routes),
        sessionConfirmDialogModule,
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MatDialogModule,
        FuseSharedModule,
    ],
    providers: [
        {provide: MatDialogRef, useValue: {close(dialogResult: any) { }}},
    ]
})
export class Login2Module
{
}
